import useViewportDimensions from "./useViewportDimensions";
import {
  determineViewportCategory,
  DESKTOP,
  MOBILE,
  TABLET,
} from "../../utils/viewport";

export { DESKTOP, MOBILE, TABLET } from "../../utils/viewport";

const useViewportCategory = () => {
  const { x } = useViewportDimensions();
  return determineViewportCategory(x);
};

export const useIsMobile = () => useViewportCategory() === MOBILE;
export const useIsTablet = () => useViewportCategory() === TABLET;
export const useIsDesktop = () => useViewportCategory() === DESKTOP;

export default useViewportCategory;
